import React from 'react';
import { Link } from 'react-router-dom';

const ListarDocumentos = ({documentos }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
            {Object.keys(documentos).map((categoria, index) => (
              <div className="accordion-item" key={index}>
                <h3 className="titulo" id={`flush-h${index}`}>Documentos - {categoria}</h3>  
                  {documentos[categoria].map((documento) => (
                    <>
                      <br/>
                      <p key={documento.id}>
                        <Link
                          className=""
                          to={`${documento.arquivo}`}
                          target='_blank'
                        >
                          {documento.nome}
                        </Link>
                      </p>
                    </>
                  ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ListarDocumentos;
